<template>
  <div class="container-fluid login-body">
    <div class="row py-5">
      <div class="bg-white itenter-pop modal-content p-4 col-lg-6 col-sm-10 state-body" 
      :class="{'shake': isErrorShake}"
      >
        <div class="auth-logo-box">
          <a href="index.html" class="logo logo-admin">
            <img src="/assets/landing/images/favicon_1.ico" alt="iTender" height="55" class="auth-logo"/>
          </a>
        </div>
        <form :key="type">
          <div class="form-row justify-content-center">
            <div class="col-md-6 mt-3 px-md-3">
              <p class="reg_radio_block" v-if="isPrivate">
                <label class="reg_radio_buttons">
                  <input type="radio" class="r_type" value="legalEntity" name="radio" v-model="type">
                  <span></span>
                  <b>Իրավաբանական անձ</b>
                </label>
                <label class="reg_radio_buttons">
                  <input type="radio" class="r_type" value="person" name="radio" v-model="type">
                  <span></span>
                  <b>Ֆիզիկական անձ</b>
                </label>
              </p>
            </div>
          </div>
          <!-- Email / Phone -->
          <div class="form-row">
            <div class="col-md-4 mb-3 px-md-3">
              <float-label class="text-secondary" :dispatch="false">
                <input
                  id="username"
                  v-model="$v.fields.username.$model"
                  type="username"
                  placeholder="Մուտքանուն"
                  class="auth-input form-control"
                  :class="{'border-danger': isInvalidField('username', 'required')}"
                  name="r_mail"
                />
              </float-label>
              <div v-if="isInvalidField('username', 'required')" class="small text-danger">{{ $t('state_customer.valid_1') }}</div>
            </div>
            <div class="col-md-4 mb-3 px-md-3">
              <float-label class="text-secondary" :dispatch="false">
                <input
                  id="email"
                  v-model="$v.fields.email.$model"
                  type="email"
                  :placeholder="$t('home.subscribe-area.placeholder')"
                  class="auth-input form-control"
                  :class="{'border-danger': isInvalidField('email', 'required') || isInvalidField('email', 'email')}"
                  name="r_mail"
                />
              </float-label>
              <div v-if="isInvalidField('email', 'required')" class="small text-danger">{{ $t('state_customer.valid_1') }}</div>
              <div v-if="isInvalidField('email', 'email')" class="small text-danger">{{ $t('state_customer.valid_2') }}</div>
            </div>
            <div class="col-md-4 mb-3 px-md-3">
              <float-label :dispatch="false">
                <vue-tel-input 
                  id="phone"
                  class="auth-input form-control"
                  :validCharactersOnly="true"
                  :inputOptions = "{'placeholder': $t('state_customer.pl_tel')}"
                  :class="{'border-danger': isInvalidField('phone', 'required') || isInvalidPhone}"
                  v-model="phoneNumber"
                  @validate="validatePhone"
                  name="r_phone"
                  v-bind="bindProps"
                >
                  <template v-slot:arrow-icon>
                    <span>{{ open ? '' : '' }}</span>
                  </template>
                </vue-tel-input>  
              </float-label>
              <div v-if="isInvalidField('phone', 'required')" class="small text-danger">{{ $t('state_customer.valid_1') }}</div>
              <div v-else-if="isInvalidPhone" class="small text-danger">{{ $t('state_customer.valid_3') }}</div>
            </div>
          </div>

          <!-- Password / Password confirm -->
          <div class="form-row">
            <div class="col-md-6 mb-3 px-md-3">
              <float-label :dispatch="false">
                <input
                  id="password"
                  v-model="$v.fields.password.$model"
                  type="password"
                  :placeholder="$t('state_customer.pl_password')"
                  class="auth-input form-control"
                  :class="{'border-danger': isInvalidField('password', 'required') || isInvalidField('password', 'minLength')}"
                  name="password"
                />
              </float-label>
              <div v-if="isInvalidField('password', 'required')" class="small text-danger">{{ $t('state_customer.valid_1') }}</div>
              <div v-if="isInvalidField('password', 'minLength')" class="small text-danger"> {{ $t('state_customer.valid_4') }}</div>
            </div>
            <div class="col-md-6 mb-3 px-md-3">
              <float-label :dispatch="false">
                <input
                  id="repeat-password"
                  v-model="$v.fields.password_confirmation.$model"
                  type="password"
                  :placeholder="$t('state_customer.repeat_pl_password')"
                  class="auth-input form-control"
                  :class="{'border-danger': isInvalidField('password_confirmation', 'required') || isInvalidField('password_confirmation', 'sameAsPassword')}"
                  name="repeat-password"
                />
              </float-label>
              <div v-if="isInvalidField('password_confirmation', 'required')" class="small text-danger">{{ $t('state_customer.valid_1') }}</div>
              <div v-if="isInvalidField('password_confirmation', 'sameAsPassword')" class="small text-danger">{{ $t('state_customer.valid_5') }}</div>
            </div>
          </div>

          <!-- Companny / Company RU -->
          <div v-if="type === 'legalEntity'">
            <div class="form-row">
              <div class="col-md-6 mb-3 px-md-3">
                <float-label :dispatch="false">
                  <input
                    v-if="isPrivate"
                    v-model="$v.fields.name.hy.$model"
                    :placeholder="$t('private_customer.user_name')"
                    type="text"
                    name="company_name"
                    class="auth-input form-control"
                    :class="{'border-danger': isInvalidField('name.hy', 'required')}"
                  />
                  <input
                    v-else
                    v-model="$v.fields.name.hy.$model"
                    :placeholder="$t('state_customer.pl_name')"
                    type="text"
                    name="company_name"
                    class="auth-input form-control"
                    :class="{'border-danger': isInvalidField('name.hy', 'required')}"
                  />
                </float-label>
                <div v-if="isInvalidField('name.hy', 'required')"
                  class="small text-danger">{{ $t('state_customer.valid_1') }}
                </div>
              </div>
              <div class="col-md-6 mb-3 px-md-3">
                <select
                  v-if="isPrivate"
                  id="company-type"
                  v-model="$v.fields.company_type.hy.$model"
                  name="company_type"
                  class="auth-input form-control my-2"
                  :class="{'border-danger': isInvalidField('company_type.hy', 'required')}"
                >
                  <option value="" disabled>Ընտրել տեսակ</option>
                  <option value="ՍՊԸ">ՍՊԸ</option>
                  <option value="Ա/Ձ">Ա/Ձ</option>
                  <option value="ԲԲԸ">ԲԲԸ</option>
                  <option value="Ա/Կ">Ա/Կ</option>
                  <option value="ՓԲԸ">ՓԲԸ</option>
                  <option value="Հիմնադրամ">Հիմնադրամ</option>
                  <option value="Հ/Կ">Հ/Կ</option>
                  <option value="other">Այլ</option>
                </select>
                <select
                  v-else
                  id="company-type"
                  v-model="$v.fields.company_type.hy.$model"
                  name="company_type"
                  class="auth-input form-control my-2"
                  :class="{'border-danger': isInvalidField('company_type.hy', 'required')}"
                >
                  <option value="" disabled>Ընտրել տեսակ</option>
                  <option value="ՍՊԸ">ՍՊԸ</option>
                  <option value="ՊՈԱԿ">ՊՈԱԿ</option>
                  <option value="ՓԲԸ">ՓԲԸ</option>
                  <option value="ՀՈԱԿ">ՀՈԱԿ</option>
                  <option value="Հիմնադրամ">Հիմնադրամ</option>
                  <option value="Համայնքապետարան">Համայնքապետարան</option>
                  <option value="Քաղաքապետարան">Քաղաքապետարան</option>
                </select>
                <div v-if="isInvalidField('company_type.hy', 'required')"
                  class="small text-danger">
                {{ $t('state_customer.valid_1') }}
                </div>
              </div>
            </div>

            <div class="form-row">
              <div class="col-md-6 mb-3 px-md-3">
                <float-label :dispatch="false">
                  <input
                    v-if="isPrivate"
                    id="name-ru"
                    v-model="$v.fields.name.ru.$model"
                    :placeholder="$t('private_customer.user_name_ru')"
                    type="text"
                    name="company_name_ru"
                    class="auth-input form-control"
                    :class="{'border-danger': isInvalidField('name.ru', 'required')}"
                  />
                  <input
                    v-else
                    id="name-ru"
                    v-model="$v.fields.name.ru.$model"
                    :placeholder="$t('state_customer.pl_name_rus')"
                    type="text"
                    name="company_name_ru"
                    class="auth-input form-control"
                    :class="{'border-danger': isInvalidField('name.ru', 'required')}"
                  />
                </float-label>
                <div v-if="isInvalidField('name.ru', 'required')"
                  class="small text-danger">
                  {{ $t('state_customer.valid_1') }}
                </div>
              </div>
              <div class="col-md-6 mb-3 px-md-3">
                <select
                  v-if="isPrivate"
                  id="company-type-ru"
                  v-model="$v.fields.company_type.ru.$model"
                  name="company_type_ru"
                  class="auth-input form-control my-2"
                  :class="{'border-danger': isInvalidField('company_type.ru', 'required')}"
                >
                  <option value="" disabled>Выбрать</option>
                  <option value="ООО">ООО</option>
                  <option value="И/П">И/П</option>
                  <option value="ОАО">ОАО</option>
                  <option value="П/О">П/О</option>
                  <option value="К/О">К/О</option>
                  <option value="ЗАО">ЗАО</option>
                  <option value="ФОНД">ФОНД</option>
                  <option value="O/О">O/О</option>
                  <option value="other">Другоe</option>
                </select>
                <select
                  v-else
                  id="company-type-ru"
                  v-model="$v.fields.company_type.ru.$model"
                  name="company_type_ru"
                  class="auth-input form-control my-2"
                  :class="{'border-danger': isInvalidField('company_type.ru', 'required')}"
                >
                  <option value="" disabled>Выбрать</option>
                  <option value="ООО">ООО</option>
                  <option value="ГНКО">ГНКО</option>
                  <option value="ЗАО">ЗАО</option>
                  <option value="ОНКО">ОНКО</option>
                  <option value="фонд">фонд</option>
                  <option value="община">община</option>
                  <option value="муниципалитет">муниципалитет</option>
                </select>
                <div v-if="isInvalidField('company_type.ru', 'required')"
                  class="small text-danger">
                  {{ $t('state_customer.valid_1') }}
                </div>
              </div>
            </div>
          </div>

          <!-- User Name -->
          <div v-else>
            <div class="form-row">
              <div class="col-md-6 mb-3 px-md-3">
                <float-label :dispatch="false">
                  <input
                    v-model="$v.fields.name.hy.$model"
                    :placeholder="$t('private_customer.user_name_surname')"
                    type="text"
                    name="company_name"
                    class="auth-input form-control"
                    :class="{'border-danger': isInvalidField('name.hy', 'required')}"
                  />
                </float-label>
                <div v-if="isInvalidField('name.hy', 'required')"
                  class="small text-danger">{{ $t('state_customer.valid_1') }}
                </div>
              </div>
              <div class="col-md-6 mb-3 px-md-3">
                <float-label :dispatch="false">
                  <input
                    v-model="$v.fields.name.ru.$model"
                    :placeholder="$t('private_customer.user_name_surname_ru')"
                    type="text"
                    name="company_name_ru"
                    class="auth-input form-control"
                    :class="{'border-danger': isInvalidField('name.ru', 'required')}"
                  />
                </float-label>
                <div v-if="isInvalidField('name.ru', 'required')"
                  class="small text-danger">{{ $t('state_customer.valid_1') }}
                </div>
              </div>
            </div>
          </div>

          <!-- Address HY -->
          <div class="form-row">
            <div class="col-md-3 mb-3 px-md-3">
              <!-- <label class="floating-label">Գործունեության հասցե *</label> -->
              <float-label :dispatch="false">
                <input
                  v-model="$v.fields.region.hy.$model"
                  :placeholder="$t('state_customer.pl_state')"
                  type="text"
                  name="company_region"
                  class="auth-input form-control"
                  :class="{'border-danger': isInvalidField('region.hy', 'required')}"
                />
              </float-label>
              <div v-if="isInvalidField('region.hy', 'required')"
                class="small text-danger">
                {{ $t('state_customer.valid_1') }}
              </div>
            </div>
            <div class="col-md-4 mb-3 px-md-3">
              <float-label :dispatch="false">
                <input
                  v-model="$v.fields.city.hy.$model"
                  :placeholder="$t('state_customer.pl_city')"
                  type="text"
                  name="company_city"
                  class="auth-input form-control"
                  :class="{'border-danger': isInvalidField('city.hy', 'required')}"
                />
              </float-label>
              <div v-if="isInvalidField('city.hy', 'required')"
                class="small text-danger">
                {{ $t('state_customer.valid_1') }}
              </div>
            </div>
            <div class="col-md-5 mb-3 px-md-3">
              <float-label :dispatch="false">
                <input
                  v-model="$v.fields.address.hy.$model"
                  :placeholder="$t('state_customer.pl_address')"
                  type="text"
                  name="company_address"
                  class="auth-input form-control"
                  :class="{'border-danger': isInvalidField('address.hy', 'required')}"
                />
              </float-label>
              <div v-if="isInvalidField('address.hy', 'required')"
                class="small text-danger">
                {{ $t('state_customer.valid_1') }}
              </div>
            </div>
          </div>

          <!-- Address RU -->
          <div class="form-row">
            <div class="col-md-3 mb-3 px-md-3">
              <!-- <label class="floating-label">Գործունեության հասցե ռուսերեն*</label> -->
              <float-label :dispatch="false">
                <input
                  v-model="$v.fields.region.ru.$model"
                  :placeholder="$t('state_customer.pl_state_rus')"
                  type="text"
                  name="company_region_ru"
                  class="auth-input form-control"
                  :class="{'border-danger': isInvalidField('region.ru', 'required')}"
                  value=""
                />
              </float-label>
              <div v-if="isInvalidField('region.ru', 'required')"
                class="small text-danger">
                {{ $t('state_customer.valid_1') }}
              </div>
            </div>
            <div class="col-md-4 mb-3 px-md-3">
              <float-label :dispatch="false">
                <input
                  v-model="$v.fields.city.ru.$model"
                  :placeholder="$t('state_customer.pl_city_rus')"
                  type="text"
                  name="company_city_ru"
                  class="auth-input form-control"
                  :class="{'border-danger': isInvalidField('city.ru', 'required')}"
                />
              </float-label>
              <div v-if="isInvalidField('city.ru', 'required')"
                class="small text-danger">
                {{ $t('state_customer.valid_1') }}
              </div>
            </div>
            <div class="col-md-5 mb-3 px-md-3">
              <float-label :dispatch="false">
                <input
                  v-model="$v.fields.address.ru.$model"
                  :placeholder="$t('state_customer.pl_address_rus')"
                  type="text"
                  name="company_address_ru"
                  class="auth-input form-control"
                  :class="{'border-danger': isInvalidField('address.ru', 'required')}"
                />
              </float-label>
              <div v-if="isInvalidField('address.ru', 'required')"
                class="small text-danger">
                {{ $t('state_customer.valid_1') }}
              </div>
            </div>
          </div>

          <!-- Soc. Card / Passport Details -->
          <div v-if="type === 'person'">
            <!-- Soc. Card Number / Passport Number -->
            <div class="form-row">
              <div class="col-md-6 mb-3 px-md-3">
                <float-label :dispatch="false">
                  <the-mask 
                    mask="###############################"
                    id="id_card_number"
                    v-model="$v.fields.id_card_number.$model"
                    type="text"
                    :placeholder="$t('private_customer.id_card_number')"
                    class="auth-input form-control"
                    :class="{'border-danger': isInvalidField('id_card_number', 'required')}"
                    name="id_card_number"
                  />
                </float-label>
                <div v-if="isInvalidField('id_card_number', 'required')" class="small text-danger">{{ $t('state_customer.valid_1') }}</div>
              </div>
              <div class="col-md-6 mb-3 px-md-3">
                <float-label :dispatch="false">
                  <input
                    id="passport_serial"
                    v-model="$v.fields.passport.serial_number.$model"
                    type="text"
                    :placeholder="$t('private_customer.passport.serial_number')"
                    class="auth-input form-control"
                    :class="{'border-danger': isInvalidField('passport.serial_number', 'required')}"
                    name="passport_serial"
                  />
                </float-label>
                <div v-if="isInvalidField('passport.serial_number', 'required')" class="small text-danger">{{ $t('state_customer.valid_1') }}</div>
              </div>
            </div>
            <!-- Passport Details -->
            <div class="form-row">
              <div class="col-md-4 mb-3 px-md-3">
                <float-label :dispatch="false">
                  <input
                    id="passport_start"
                    v-model="$v.fields.passport.given_at.$model"
                    type="text"
                    v-mask="'##/##/####'"
                    :placeholder="$t('private_customer.passport.given_at')"
                    class="auth-input form-control"
                    :class="{'border-danger': isInvalidField('passport.given_at', 'required')}"
                    name="passport_start"
                  />
                </float-label>
                <div v-if="isInvalidField('passport.given_at', 'required')" class="small text-danger">{{ $t('state_customer.valid_1') }}</div>
                <div v-if="isInvalidField('passport.given_at', 'validDate')" class="small text-danger">{{ $t('private_customer.valid_phone') }}</div>
              </div>
              <div class="col-md-4 mb-3 px-md-3">
                <float-label :dispatch="false">
                  <input
                    id="passport_end"
                    v-model="$v.fields.passport.valid_until.$model"
                    type="tel"
                    v-mask="'##/##/####'"
                    :placeholder="$t('private_customer.passport.valid_until')"
                    class="auth-input form-control"
                    :class="{'border-danger': isInvalidField('passport.valid_until', 'required')}"
                    name="passport_end"
                  />
                </float-label>
                <div v-if="isInvalidField('passport.valid_until', 'required')" class="small text-danger">{{ $t('state_customer.valid_1') }}</div>
                <div v-if="isInvalidField('passport.valid_until', 'validDate')" class="small text-danger">{{ $t('private_customer.valid_phone') }}</div>
              </div>
              <div class="col-md-4 mb-3 px-md-3">
                <float-label :dispatch="false">
                  <the-mask 
                    mask="###"
                    v-model="$v.fields.passport.from.$model"
                    id="passport_who"
                    :placeholder="$t('private_customer.passport.from')"
                    class="auth-input form-control"
                    :class="{'border-danger': isInvalidField('passport.from', 'required')}"
                    name="passport_who"
                  />
                </float-label>
                <div v-if="isInvalidField('passport.from', 'required')" class="small text-danger">{{ $t('state_customer.valid_1') }}</div>
              </div>
            </div>
          </div>

          <!-- Bank Details -->
          <div class="form-row">
            <div class="col-md-6 mb-3 px-md-3">
              <float-label :dispatch="false">
                <input
                  id="bank-name"
                  v-model="$v.fields.bank_name.hy.$model"
                  :placeholder="isPrivate ? $t('private_customer.pl_bank') : $t('state_customer.pl_bank')"
                  type="text"
                  name="bank_name"
                  class="auth-input form-control"
                  :class="{'border-danger': isInvalidField('bank_name.hy', 'required')}"
                />
              </float-label>
              <div v-if="isInvalidField('bank_name.hy', 'required')"
                class="small text-danger">
                {{ $t('state_customer.valid_1') }}
              </div>
            </div>
            <div class="col-md-6 mb-3 px-md-3">
              <float-label :dispatch="false">
                <input
                  v-model="$v.fields.bank_name.ru.$model"
                  :placeholder="isPrivate ? $t('private_customer.pl_bank_rus') : $t('state_customer.pl_bank_rus')"
                  type="text"
                  name="bank_name_ru"
                  class="auth-input form-control"
                  :class="{'border-danger': isInvalidField('bank_name.ru', 'required')}"
                />
              </float-label>
              <div v-if="isInvalidField('bank_name.ru', 'required')"
                class="small text-danger">
                {{ $t('state_customer.valid_1') }}
              </div>
            </div>
          </div>

          <!-- Bank Account Details -->
          <div v-if="type === 'legalEntity'">
            <div class="form-row" >
              <div class="col-md-6 mb-3 px-md-3">
                <float-label :dispatch="false">
                  <the-mask 
                    id="bank-account"
                    v-model="$v.fields.bank_account.$model"
                    :placeholder="$t('state_customer.pl_account_number')"
                    type="text"
                    min="0"
                    name="bank_account"
                    maxlength="16"
                    class="auth-input form-control"
                    :class="{'border-danger': isInvalidField('bank_account', 'required')}"
                    mask="###############################"
                  />
                </float-label>
                <div v-if="isInvalidField('bank_account', 'required')"
                  class="small text-danger">
                  {{ $t('state_customer.valid_1') }}
                </div>
              </div>
              <div class="col-md-6 mb-3 px-md-3">
                <float-label :dispatch="false">
                  <the-mask 
                    mask="###############################"
                    id="tin"
                    v-model="$v.fields.tin.$model"
                    :placeholder="$t('state_customer.pl_hvhh')"
                    type="text"
                    name="hvhh"
                    class="auth-input form-control"
                    :class="{'border-danger': isInvalidField('tin', 'required')}"
                  />
                </float-label>
                <div v-if="isInvalidField('tin', 'required')"
                  class="small text-danger">
                  {{ $t('state_customer.valid_1') }}
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col-md-6 mb-3 px-md-3">
                <float-label v-if="isPrivate" :dispatch="false">
                  <input
                    id="director-name-hy"
                    v-model="$v.fields.director_name.hy.$model"
                    :placeholder="$t('private_customer.user_director')"
                    type="text"
                    name="director_name"
                    class="auth-input form-control"
                    :class="{'border-danger': isInvalidField('director_name.hy', 'required')}"
                  />
                </float-label>
                <float-label v-else :dispatch="false">
                  <input
                    id="pl-name-hy"
                    v-model="$v.fields.director_name.hy.$model"
                    :placeholder="$t('state_customer.pl_name_surname')"
                    type="text"
                    name="director_name"
                    class="auth-input form-control"
                    :class="{'border-danger': isInvalidField('director_name.hy', 'required')}"
                  />
                </float-label>
                <div v-if="isInvalidField('director_name.hy', 'required')"
                  class="small text-danger">
                  {{ $t('state_customer.valid_1') }}
                </div>
              </div>
              <div class="col-md-6 mb-3 px-md-3">
                <float-label v-if="isPrivate" :dispatch="false">
                  <input
                    id="director-name-ru"
                    v-model="$v.fields.director_name.ru.$model"
                    :placeholder="$t('private_customer.user_director_ru')"
                    type="text"
                    name="director_name"
                    class="auth-input form-control"
                    :class="{'border-danger': isInvalidField('director_name.ru', 'required')}"
                  />
                </float-label>
                <float-label v-else :dispatch="false">
                  <input
                    id="director-name-ru"
                    v-model="$v.fields.director_name.ru.$model"
                    :placeholder="$t('state_customer.pl_name_surname_rus')"
                    type="text"
                    name="director_name_ru"
                    class="auth-input form-control"
                    :class="{'border-danger': isInvalidField('director_name.ru', 'required')}"
                  />
                </float-label>
                <div v-if="isInvalidField('director_name.ru', 'required')"
                  class="small text-danger">
                  {{ $t('state_customer.valid_1') }}
                </div>
              </div>
            </div>

            <div v-if="!isPrivate" class="form-row">
              <div class="col-md-6 mb-3 px-md-3">
                <float-label :dispatch="false">
                  <input
                    id="director-name-hy"
                    v-model="$v.fields.director_position.hy.$model"
                    :placeholder="$t('state_customer.pl_position')"
                    type="text"
                    name="director_position"
                    class="auth-input form-control"
                    :class="{'border-danger': isInvalidField('director_position.hy', 'required')}"
                  />
                </float-label>
                <div v-if="isInvalidField('director_position.hy', 'required')"
                  class="small text-danger">
                  {{ $t('state_customer.valid_1') }}
                </div>
              </div>
              <div class="col-md-6 mb-3 px-md-3">
                <float-label :dispatch="false">
                  <input
                    id="director-name-ru"
                    v-model="$v.fields.director_position.ru.$model"
                    :placeholder="$t('state_customer.pl_position_rus')"
                    type="text"
                    name="director_position"
                    class="auth-input form-control"
                    :class="{'border-danger': isInvalidField('director_position.ru', 'required')}"
                  />
                </float-label>
                <div v-if="isInvalidField('director_position.ru', 'required')"
                  class="small text-danger">
                  {{ $t('state_customer.valid_1') }}
                </div>
              </div>
            </div>

          </div>

          <!-- Bank Name -->
          <div class="form-row" v-if="type === 'person'">
            <div class="col-md-6 mb-3 px-md-3">
              <float-label :dispatch="false">
                <input
                  id="bank-account"
                  v-model="$v.fields.bank_account.$model"
                  :placeholder="$t('state_customer.pl_account_number')"
                  type="number"
                  min="0"
                  name="bank_account"
                  maxlength="16"
                  class="auth-input form-control"
                  :class="{'border-danger': isInvalidField('bank_account', 'required')}"
                />
              </float-label>
              <div v-if="isInvalidField('bank_account', 'required')"
                class="small text-danger">
                {{ $t('state_customer.valid_1') }}
              </div>
            </div>
          </div>

          <label class="myCheckbox" style="margin-top: 12px">
            <input
              v-model="$v.agreeToTerms.$model"
              type="checkbox"
              name="r_remember"
              class="r_checkbox"
              :class="{'border-danger': agreeToTerms}"
            />
            <span></span>
            <p v-if="$v.agreeToTerms.$dirty && $v.agreeToTerms.$invalid" class="small text-danger i_agree i_agree_tender small">
              {{ $t('state_customer.studied') }}
              <a href="regulation.html" target="_blank">{{ $t('state_customer.regulation') }}</a> {{ $t('state_customer.regulation_text') }}
            </p>
            <p v-else class="i_agree i_agree_tender small">
              {{ $t('state_customer.studied') }}
              <a href="regulation.html" target="_blank">{{ $t('state_customer.regulation') }}</a> {{ $t('state_customer.regulation_text') }}
            </p>
          </label>
          <div class="reg_form">
            <label class="robot small">
              <span>    {{ $t('state_customer.code') }}</span>
              <VueRecaptcha :sitekey="this.sitekey" :loadRecaptchaScript="true" language='hy' @verify="validate"/>
              <div v-if="$v.captcha.$dirty && $v.captcha.$invalid"
                class="small text-danger">
                {{ $t('state_customer.valid_captcha') }}
              </div>
            </label>
          </div>
          <div class="form-group row justify-content-center mt-5">
          <span v-if="errorMsgFromApi" 
                    class="d-block w-100 text-center text-danger" 
                    style="top: -1.5rem;">Մուտքանունը զբաղված է</span>
            <div class="col-sm-3">
              <button @click.prevent="signup" name="signup-btn" class="btn signup-btn_02" id="signup-btn "> {{ $t('state_customer.btn_register') }}</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { email, required, minLength, sameAs, numeric } from 'vuelidate/lib/validators'
import VueRecaptcha from 'vue-recaptcha'
import moment from 'moment'

const validDate = (value, vm) => {
  var date = moment(value, "DD-MM-YYYY");
  var currentDate = moment(new Date());
  var yearDiff = currentDate.year() - date.year();
  if(!date.isValid() || yearDiff > 10) {
    return false
  }
  return true
};
export default {
  name: 'StateSignup',
  components: {VueRecaptcha},
  data () {
    return {
      bindProps: {
        defaultCountry : "AM",
        autoDefaultCountry: false,
        dropdownOptions: {
          showDialCodeInList: true,
          showFlags: true,
          showDialCodeInSelection: true
        },
      },
      sitekey: "6LeRVEEaAAAAAJU28gZTNKGoVpfZJ3tHidw8Nx48",
      phoneNumber: "",
      isInvalidPhone: false,
      type: 'legalEntity',
      isErrorShake: false,
      fields: {
        // type: this.$route.params.type,
        type: this.$route.params.type === "private" ? 'user' : this.$route.params.type,
        name: {
          hy: '',
          ru: '',
        },
        email: '',
        username: '',
        password: '',
        password_confirmation: '',
        phone: '',
        tin: '',
        passport: {
          serial_number: '',
          given_at: '',
          from: '',
          valid_until: '',
        },
        id_card_number: '',
        bank_account: '',
        region: {
          hy: '',
          ru: '',
        },
        city: {
          hy: '',
          ru: '',
        },
        address: {
          hy: '',
          ru: '',
        },
        bank_name: {
          hy: '',
          ru: '',
        },
        director_name: {
          hy: '',
          ru: '',
        },
        director_position: {
          hy: '',
          ru: '',
        },
        company_type: {
          hy: '',
          ru: '',
        }
      },
      agreeToTerms: false,
      captcha: false,
      errorMsgFromApi: '',
      userType: this.$route.params.type,
      isPrivate: this.$route.params.type === 'private'
    }
  },
  methods: {
    open(){
      console.log(1)
    },
    validate () {
      this.$v.captcha.$model = true;
    },
    validatePhone (item) {
      const valid = item.valid;
      if (valid !== undefined){
        this.$v.fields.phone.$model = item.number;
        if(!item.valid){
          this.isInvalidPhone = true;
        }
        else{
          this.isInvalidPhone = false;
        }
      }
    },
    signup () {
      if(!this.$v.fields.$invalid && this.agreeToTerms && !this.isInvalidPhone) {
        if(this.fields.company_type.hy === 'other'){
          this.fields.company_type.hy = '';
        }
        if(this.fields.company_type.ru === 'other'){
          this.fields.company_type.ru = '';
        }
        this.$store.dispatch('auth', {
          url: 'signup',
          fields: this.fields,
          rememberMe: false,
          type: this.fields.type,
        })
          .then(response => {
            if (response.message === "Validation Error") {
              this.isErrorShake = true
              setTimeout(() => {
                this.isErrorShake = false
              }, 700)
              this.errorMsgFromApi = response.message
            } else {
              this.$router.push({ path: '/login' })
            }
          }) 
      } else {
        this.$v.fields.$touch()
        this.$v.agreeToTerms.$touch()
        this.$v.captcha.$touch()
      }
    },
    isInvalidField (pathToField, validator) {
      const keyArr = pathToField.split('.')
      const field = keyArr.reduce((acc, key) => {
        return acc[key]
      }, this.$v.fields)
      return validator === 'required' ?
        field.$dirty && !field.required :
        field.required && !field[validator]
    }
  },
  validations() {
    const validationRules = {
      fields: {
        type: {},
        name: {
          hy: { required },
          ru: { required },
        },
        username: { required },
        email: { required, email },
        password: { required, minLength: minLength(6) },
        password_confirmation: { required, sameAsPassword: sameAs('password') },
        phone: { required },
        bank_account: { required, numeric },
        region: {
          hy: { required },
          ru: { required },
        },
        city: {
          hy: { required },
          ru: { required },
        },
        address: {
          hy: { required },
          ru: { required },
        },
        bank_name: {
          hy: { required },
          ru: { required },
        },
      },
      captcha: { checked: value => value === true },
      agreeToTerms: { checked: value => value === true },
    }

    if(!this.isPrivate){
      const privateValidationRules = {
        director_position: {
          hy: { required },
          ru: { required },
        },
      }
      validationRules.fields = Object.assign(validationRules.fields, privateValidationRules);
    }
    if (this.type === 'person') {
      console.log('HERE')
      const privateValidationRules = {
        passport: {
          serial_number: { required },
          given_at: { required, validDate },
          from: { required, numeric },
          valid_until: { required, validDate },
        },
        id_card_number: { required, numeric }
      }
      validationRules.fields = Object.assign(validationRules.fields, privateValidationRules);
      return validationRules;
    } else {
      const stateValidationRules = {
        company_type: {
          hy: { required },
          ru: { required },
        },
        director_name: {
          hy: { required },
          ru: { required },
        },
        tin: { required, numeric },
      }
      validationRules.fields = Object.assign(validationRules.fields, stateValidationRules);
      return validationRules;
    }
  }
}
</script>

<style scoped>
.auth-input {
  border-radius: 0;
  border: none;
  border-bottom: 1px solid #ddd;
  padding: 0;
}
.auth-input:focus {
  box-shadow: 0 1px 0 #ddd!important;
}
</style>
<style lang="scss" scoped>
@import '@/assets/styles/main.scss';
</style>
